import { FCX } from "@datassential/platform-ui-lib";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import TopFoodBeveragePosts from "@components/TopFoodBeveragePosts/TopFoodBeveragePosts";
import { useTopFoodBeveragePosts } from "@apiHooks/useTopFoodBeveragePosts";
import './HomeTopFoodBeveragePosts.scss';

const HomeTopFoodBeveragePosts: FCX = () => {
    const { data, isLoading } = useTopFoodBeveragePosts();

    return (
        <TopFoodBeveragePosts
            className="HomeTopFoodBeveragePosts"
            data={data}
            isLoading={isLoading}
            isDark
            showFollowers
            prevIcon={<IoChevronBack/>}
            nextIcon={<IoChevronForward/>}
        />
    );
};

export default HomeTopFoodBeveragePosts;
